import { render, staticRenderFns } from "./MateriPelatihanPetani.vue?vue&type=template&id=7fe275f4"
import script from "./MateriPelatihanPetani.vue?vue&type=script&lang=js"
export * from "./MateriPelatihanPetani.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports